import { render, staticRenderFns } from "./DuesConversation.vue?vue&type=template&id=4652d80d&scoped=true"
import script from "./DuesConversation.vue?vue&type=script&lang=js"
export * from "./DuesConversation.vue?vue&type=script&lang=js"
import style0 from "./DuesConversation.vue?vue&type=style&index=0&id=4652d80d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4652d80d",
  null
  
)

export default component.exports